var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"space-py-0 space-py-8--m"},[_c('div',{staticClass:"page-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }